import { render, staticRenderFns } from "./company_detail.vue?vue&type=template&id=483f85b7&scoped=true"
import script from "./company_detail.vue?vue&type=script&lang=js"
export * from "./company_detail.vue?vue&type=script&lang=js"
import style0 from "./company_detail.vue?vue&type=style&index=0&id=483f85b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483f85b7",
  null
  
)

export default component.exports